export enum DermloopPushDeviceType {
  GOOGLE = 'GOOGLE',
  APPLE = 'APPLE',
}
